import { RequestDto } from '@r1-frontend/api-domru/api-tariffs/v1/tariff/calculate/dto/RequestDto';

import { IRequest } from '@r1-frontend/shared/types/IRequest';

/**
 * Метод расчета данны тарифа для конструктора
 * @link https://master.api-tariffs.sandbox.d2c.r-one.io/docs/#/Tariff/TariffController_calculate
 */
const calculate = (request: RequestDto, withAuth = false): IRequest => ({
    uri: 'v1/tariff/calculate',
    method: 'POST',
    body: JSON.stringify(request),
    withProvider: true,
    withAuth,
});

export default calculate;
